import { baseApi } from '@ibk/shared-config';
export const contabilCompanyLinkFeatureFlagsApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        getIntegrationFeatureFlagsForParty: builder.query({
            query: ({ partyId }) => ({
                url: '/v1/feature-flags',
                headers: { 'x-tr-party-selected': partyId },
            }),
            transformResponse: (response) => response.result,
        }),
    }),
    overrideExisting: false,
});
export const { useLazyGetIntegrationFeatureFlagsForPartyQuery } = contabilCompanyLinkFeatureFlagsApi;
